// import 'slick-carousel';
//import $ from 'jquery';
// import scrollLock from 'scroll-lock'
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { CustomEase } from "gsap/CustomEase";
// import { Observer } from "gsap/Observer";

//gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,CustomEase,Observer);

ScrollTrigger.refresh();
var is_US = false;

if ($(".html--product-type--core").length) {
    const isMobile = window.matchMedia('(max-width: 700px)').matches;
    $(document).ready(function() {
        is_US = $("body").hasClass("en-us");
        if($(".html--product-type--core").length) {
            
            if ($(".grand-chateau").length) {
                 $('.bottom_teaser .center_image').show();
            } else {
                $('.bottom_teaser .center_image').hide();
                $('.bottom_teaser').attr('style', 'position: absolute !important');
                animateCoreProduct(isMobile);       
            }
        }
        
    });
    var doneAnimating = true;
   
    function doneAnimatingFunc()
    {
        doneAnimating = true;
        scrollLock.enablePageScroll();
    }
    function animateCoreProduct(is_mobile)
    {
        setAnimationVideStartEnd();
        clearInterval(interval);
        setPlayerTimeline(animTimelineFirstStart, animTimelineFirstEnd);
        interval = setInterval(setPlayerTimeline, ((animTimelineFirstEnd - animTimelineFirstStart) * 1000), animTimelineFirstStart, animTimelineFirstEnd);
        if (is_mobile) {
            animateCoreMobile();
        } else {
            animateCoreDesktop();
        }
    }
    
    var tastingNotesObserver = null;
    var mobile_slides = null;
    var tastingIsAnimating = false;
    var tastingIndex = 0;
    var source_scroll = false;
    
    function initializeTastingNoteObserverGC()
    {
        mobile_slides = $(".mobile-note-slide");
        
        tastingNotesObserver = Observer.create({
            type: "wheel,touch,pointer",
            wheelSpeed: -1,
            onDown: () => {
                !animating && tastingNotePrevGC(tastingIndex - 1, down);
            },
            onUp: () => {
                !animating && tastingNoteNextGC(tastingIndex + 1, up);
            },
            onUpdate: () => {
            },
            tolerance: 40,
            preventDefault: true,
        });
        
        if ($('.tasting_notes_slider .slide-active-video').length) {
            $(".tasting_notes_slider .slide-active-video").on('loadedmetadata', function() {
                this.width = this.videoWidth;
                this.height = this.videoHeight;
            });    
            
            $('video').on('play', function (e) {
                // do something
            });
        }
        
        $(".mobile-note-slide").on('click', function() {
            
            if (!isMobile) {
                tastingIndex = $(this).index();
                
                if (tastingIndex != 0 && tastingIndex != (mobile_slides.length - 1) ) {
                    tastingNotesObserver.enable();
                }    
            }
        });
    }
    
    function initializeTastingNoteObserver()
    {
        mobile_slides = $(".mobile-note-slide");
        
        tastingNotesObserver = Observer.create({
            type: "wheel,touch,pointer",
            wheelSpeed: -1,
            onDown: () => {
                !animating && tastingNotePrev(tastingIndex - 1, down);
            },
            onUp: () => {
                !animating && tastingNoteNext(tastingIndex + 1, up);
            },
            onUpdate: () => {
            },
            tolerance: 40,
            preventDefault: true,
        });
        
        if ($('.tasting_notes_slider .slide-active-video').length) {
            $(".tasting_notes_slider .slide-active-video").on('loadedmetadata', function() {
                this.width = this.videoWidth;
                this.height = this.videoHeight;
            });    
            
            $('video').on('play', function (e) {
                // do something
            });
        }
        
        $(".mobile-note-slide").on('click', function() {
            
            if (!isMobile) {
                tastingIndex = $(this).index();
                
                if (tastingIndex != 0 && tastingIndex != (mobile_slides.length - 1) ) {
                    tastingNotesObserver.enable();
                }    
            }
        });
    }
    function scrollNextSlide(source)
    {
        var target_id = "#" + source;
        
        $('.tasting_notes_slider .mobile-note-slides .mobile-note-slide').removeClass('active').css('opacity', '0.3');
		$(target_id).addClass('active').css('opacity', '1');
// 		$('.tasting_notes_slider').css('background-image', 'url(' + $(source).find('picture img').attr('src') + ')');
		// Change the source of the video element of '.tasting_notes_slider .slide-active-video' to this active element's video source child and play it
		$(".slide-active-video").css('display', "none");
		$("#video_" + source).css('display', 'block');
// 		$('.tasting_notes_slider .slide-active-video source').attr('src', $(target_id).find('video source').attr('src'));
// 		$('.tasting_notes_slider .slide-active-video source').on('play', function() {
// 		    alert("Playing video");
// 		});
		if (typeof $('.tasting_notes_slider .slide-active-video')[0] !== "undefined") {
		    
		    jQuery('.slide-active-video').each(function () {
    			jQuery(this).get(0).pause();
    // 			return false;
    		});
    		
// 			$('.tasting_notes_slider .slide-active-video').get(0).load();
		    $("#video_" + source).get(0).play();
		  //  $('.tasting_notes_slider .mobile-note-slides .mobile-note-slide').not($(target_id)).find('video').css('display', 'none').get(0).pause();
		}    
    }
    
    function scrollNextImage(source)
    {
        var target_id = "#" + source;
        
        $('.tasting_notes_slider .mobile-note-slides .mobile-note-slide').removeClass('active').css('opacity', '0.3');
		$(target_id).addClass('active').css('opacity', '1');
		var imgSrc = $(target_id).find(".media-holder").find('img').attr('src');
		$(".image-as-background").css('background-image', 'url(' + imgSrc + ')')
		
    }
    
    function tastingNotePrevGC(index, direction)
    {
        source_scroll = true;
        animating = true;
        tastingIndex = index;
        var targetElem = $(mobile_slides[index]);
        
        if (!targetElem) {
            animating = false;
            return false;
        }
        
        var id = targetElem.attr('id');

        if (id == "") {
            animating = false;
            return false;
        }
        
        if (index < 0) {
            
            animating = false;
            tastingIndex = 0;
            tastingNotesObserver.disable();
            // gsap.to(window, {
            //   scrollTo: {y: ".scrolltrigger", autoKill: false},
            //   duration: 1,
            //   ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
            //   onComplete: () => {
                tastingNotesObserver.disable();
            //   }
            // });
        
            return false;
        } else {
            
            scrollNextSlide(id);
            // $("#" + id).trigger('click');
            setTimeout(function() {
                animating = false;    
            }, 800);
            
            return true;
        }
    }
    
    function tastingNoteNextGC(index, direction)
    {
        animating = true;
        tastingIndex = index;
        
        var targetElem = $(mobile_slides[index]);
        
        if (!targetElem) {
            animating = false;
            return false;
        }
        
        var id = targetElem.attr('id');
        
        if (id == "") {
            animating = false;
            return false;
        }
        if (index >= mobile_slides.length) {
            animating = false;
            tastingIndex = mobile_slides.length - 1;
            // gsap.to(window, {
            //   scrollTo: {y: ".orchard-slider", autoKill: false},
            //   duration: 1,
            //   ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
            //   onComplete: () => {
                tastingNotesObserver.disable();
            //   }
            // });
            
            return false;
        } else {
            // $(".mobile-note-slide").get(index).trigger('click');
            // $("#" + id).trigger('click');
            scrollNextSlide(id);
            setTimeout(function() {
                animating = false;    
            }, 800);
            return true;
        }
    }
    
    function tastingNotePrev(index, direction)
    {
        source_scroll = true;
        animating = true;
        tastingIndex = index;
        var targetElem = $(mobile_slides[index]);
        
        if (!targetElem) {
            animating = false;
            return false;
        }
        
        var id = targetElem.attr('id');

        if (id == "") {
            animating = false;
            return false;
        }
        
        if (index < 0) {
            
            animating = false;
            tastingIndex = 0;
            tastingNotesObserver.disable();
            gsap.to(window, {
              scrollTo: {y: ".scrolltrigger", autoKill: false},
              duration: 1,
              ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
              onComplete: () => {
                tastingNotesObserver.disable();
              }
            });
        
            return false;
        } else {
            
            scrollNextSlide(id);
            // $("#" + id).trigger('click');
            setTimeout(function() {
                animating = false;    
            }, 800);
            
            return true;
        }
    }
    
    function tastingNoteNext(index, direction)
    {
        animating = true;
        tastingIndex = index;
        
        var targetElem = $(mobile_slides[index]);
        
        if (!targetElem) {
            animating = false;
            return false;
        }
        
        var id = targetElem.attr('id');
        
        if (id == "") {
            animating = false;
            return false;
        }
        if (index >= mobile_slides.length) {
            animating = false;
            tastingIndex = mobile_slides.length - 1;
            gsap.to(window, {
              scrollTo: {y: ".orchard-slider", autoKill: false},
              duration: 1,
              ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
              onComplete: () => {
                tastingNotesObserver.disable();
              }
            });
            
            return false;
        } else {
            // $(".mobile-note-slide").get(index).trigger('click');
            // $("#" + id).trigger('click');
            scrollNextSlide(id);
            setTimeout(function() {
                animating = false;    
            }, 800);
            return true;
        }
    }
    function animateCoreMobile()
    {
        
        // Where Next Slider
    	const tastingNotesAnimate = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.html--product-type--core .whisky-notes',
    			start: 'top+=1 bottom',
    			end: 'bottom top',
    			toggleActions: 'play none play reset',
    			onEnter: (section) => {
    			    
                     gsap.to(window, {
                      scrollTo: {y: ".whisky-notes", autoKill: false},
                      duration: 1,
                      ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                      onComplete: () => {
                          
                        if ($(".whisky-notes").hasClass("tasting_notes_slider")) {
                            initializeTastingNoteObserver();      
                        }
                      }
                    });
    			},
    			onEnterBack: () => {
    			    
    			    gsap.to(window, {
                      scrollTo: {y: ".whisky-notes", autoKill: false},
                      duration: 1,
                      ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                      onComplete: () => {
                          if ($(".whisky-notes").hasClass("tasting_notes_slider")) {
                            initializeTastingNoteObserver();
                          }
                      }
                    });
    			},
    			onLeave: () => {
			        tastingNotesObserver.disable()
    			},
    			onLeaveBack: () => {
			        tastingNotesObserver.disable()
    			},
    		}
    	});
        
        if (!is_US) {
            ScrollTrigger.create({
                trigger: ".html--product-type--core .scrolltrigger",
                start: "top-=1 top",
                end: "bottom bottom",
                // markers: true,
                onEnter: () =>  {
                  const enterAnim = gsap.timeline();          
                //   enterAnim.fromTo("#header", { autoAlpha: 1, zIndex: 10 }, { autoAlpha: 1, zIndex: -1, duration: 0.5 }, 0)
                  $("#header").toggleClass("minimize");
                  enterAnim.fromTo("#whisky-cta", { autoAlpha: 0, zIndex: 1 }, { autoAlpha: 1, zIndex: 9, duration: 0.5 }, 0);
                  if ($(".black-header").length) {
                    $(".menu-toggle").toggleClass("white-menu");    
                  }
                },
                onEnterBack: () => {
                  
                },
                onLeaveBack: () => {
                  const enterAnim2 = gsap.timeline();
                //   enterAnim2.fromTo("#header", { autoAlpha: 1, zIndex: -1}, { autoAlpha: 1, zIndex: 10, duration: 0.5 }, 0)
                  $("#header").toggleClass("minimize");
                  enterAnim2.fromTo("#whisky-cta", { autoAlpha: 1, zIndex: 9}, { autoAlpha: 0, zIndex: -1, duration: 0.5 }, 0);
                  if ($(".black-header").length) {
                    $(".menu-toggle").toggleClass("white-menu");    
                  }
                },
                onLeave: () => {
                  
                }
            });
        }
        
        
    	const doublePanelContentIntroAnimate = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.html--product-type--core .paragraph--type--double-panel-content',
    			//markers: true,
    			start: 'top+=1 bottom',
    			end: 'top-=1 top',
    			toggleActions: 'play none play reset',
    			onEnter: (section) => {
    			},
    		}
    	});
    	doublePanelContentIntroAnimate.from('.paragraph--type--double-panel-content .paragraph_content', { duration: 0.5, opacity: 0, y: 200, ease: "power1.out" }, 0.7)
    		.from('.paragraph--type--double-panel-content .paragraph_image img', { duration: 0.5, opacity: 0, y: 250, ease: "power1.out" }, 0.9);
    
    	// Where Next Slider
    	const simpleTastingNotesSliderAnimate = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.html--product-type--core .paragraph--type--carousel-section.tasting_notes',
    			start: 'top+=1 bottom',
    			end: 'top-=1 top',
    			toggleActions: 'play none play reset',
    			onEnter: (section) => {
    			},
    		}
    	});
    	simpleTastingNotesSliderAnimate.from('.paragraph--type--carousel-section.tasting_notes .paragraph_title', { duration: 1, opacity: 0, y: 50, ease: "power1.out" }, 0.3)
    		.from('.paragraph--type--carousel-section.tasting_notes .mobile-note-slides .mobile-note-slide .slide-down-holder', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.5)
    		.from('.paragraph--type--carousel-section.tasting_notes .mobile-note-slides .mobile-note-slide p', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.5);
    
    	// Where Next Slider
    	const whereNextSliderAnimate = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.html--product-type--core .where-next',
    			start: 'top+=1 bottom',
    			end: 'top-=1 top',
    			toggleActions: 'play none play reset',
    			onEnter: (section) => {
    			},
    		}
    	});
    	whereNextSliderAnimate.set('.where-next .title-and-nav', { zIndex: 9 }, 0)
    		.from('.where-next .title-and-nav', { duration: 1, opacity: 0, y: 50, ease: "power1.out" }, 0.5)
    		.from('.collection-whisky-listing .collection-slide-image-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.8)
    		.from('.collection-whisky-listing .collection-content-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 1);
    
    	
    }
    
    const observer_sections = document.querySelectorAll(".observer");
    var currentIndex = 0;
    var animating = false;
    const down = -1;
    const up = 1;
    let startTime = 0;
    let endTime = 0;
    let timeDiff = 0;
    let interval = null;
    let prevInterval = interval;
    let descriptionPosition = "-90vh";
    const player = document.querySelectorAll(".whisky-hero-video-bg")
    
    /*
     * Set the video player start and end timeline per animation section
    */
    let animTimelineFirstStart = 0;
    let animTimelineFirstEnd = 5;
    let animTimelineSecondStart = 5;
    let animTimelineSecondEnd = 10;
    let animTimelineThirdStart = 11;
    let animTimelineThirdEnd = 16;
    
    function setAnimationVideStartEnd()
    {
        if ($(".grandcru23").length) {
            descriptionPosition = "-70vh";
        }
        
        if ($(".grand-yozakura").length) {
            animTimelineFirstStart = 0;
            animTimelineFirstEnd = 6;
            animTimelineSecondStart = 7;
            animTimelineSecondEnd = 12;
            animTimelineThirdStart = 0;
            animTimelineThirdEnd = 6;
        }
        
        if ($(".twelve-years-old-time").length) {
            animTimelineFirstStart = 0;
            animTimelineFirstEnd = 8;
            animTimelineSecondStart = 8;
            animTimelineSecondEnd = 16;
            animTimelineThirdStart = 0;
            animTimelineThirdEnd = 8;
        }
        
        if ($(".gran-reserva-time").length) {
            animTimelineFirstStart = 0;
            animTimelineFirstEnd = 9;
            animTimelineSecondStart = 9;
            animTimelineSecondEnd = 18;
            animTimelineThirdStart = 0;
            animTimelineThirdEnd = 9;
        }
        
        if ($(".fifteen-years-old-time").length) {
            animTimelineFirstStart = 0;
            animTimelineFirstEnd = 11;
            animTimelineSecondStart = 12;
            animTimelineSecondEnd = 23;
            animTimelineThirdStart = 0;
            animTimelineThirdEnd = 11;
        }
        
        if ($(".eighteen-years-old-time").length) {
            animTimelineFirstStart = 0;
            animTimelineFirstEnd = 11;
            animTimelineSecondStart = 0;
            animTimelineSecondEnd = 11;
            animTimelineThirdStart = 0;
            animTimelineThirdEnd = 11;
        }
    }
    /*
    * End animation timeline
    */
    
    var observer = null;
    var observerFirst = null;
    var grandVideo = null;
    
    
    function createObserverTrigger()
    {
        
        observer = Observer.create({
            // target: ".paragraph--type--timeline-item",
            // ignore: [".scrolltrigger"],
            type: "wheel,touch,pointer",
            wheelSpeed: -1,
            onDown: () => {
                
                if (currentIndex == 0 && !animating) {
                    gsap.to(window, {
                      scrollTo: {y: ".section-hero--container", autoKill: false},
                      duration: 1,
                      ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                      onComplete: () => {
                        
                        grandVideo.addEventListener('wheel', handleWheelEvent);
                        observer.disable();
                      }
                    });
                    
                }
                
                if (isMobile) {
                    !animating && animateSectionDownMob(currentIndex - 1, down);
                } else {
                    !animating && animateSectionDown(currentIndex - 1, down);
                }
            },
            onUp: () => {
                
                if (isMobile) {
                    !animating && animateSectionUpMob(currentIndex + 1, up);
                } else {
                    !animating && animateSectionUp(currentIndex + 1, up);
                }
            },
            onUpdate: () => {
            },
            tolerance: 40,
            preventDefault: true,
        });
    }
    
    function handleWheelEvent(event) {
        event.preventDefault();
        var jumpspeed = 0.03;
        // Determine the direction of the scroll
        // Scroll up (positive delta) fast forwards, scroll down (negative delta) rewinds
        var delta = event.deltaY;
        
        // Define the amount of time to skip, e.g., 5 seconds
        var skipTime = jumpspeed;
        
        // Calculate the new time
        if (delta > 0) {
        // Scroll down (negative delta), rewind
            grandVideo.currentTime = Math.max(0, grandVideo.currentTime + skipTime);
            if (grandVideo.currentTime >= grandVideo.duration) {
                grandVideo.removeEventListener('wheel', handleWheelEvent);
                gsap.to(window, {
                  scrollTo: {y: ".bottom_teaser", autoKill: false},
                  duration: 1,
                  ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                  onComplete: () => {
                    fadeMenu();
                    // createObserverTrigger();
                  }
                });
                
            }
        } else {
        // Scroll up (positive delta), fast forward
            grandVideo.currentTime = Math.min(grandVideo.duration, grandVideo.currentTime - skipTime);
            showMenu();
        }
    }
    
    function attachScrollTriggerTo(classTarget)
    {
        ScrollTrigger.create({
            trigger: classTarget,
            start: "top-=1 top",
            end: "bottom bottom",
            onEnter: () =>  {
                animating = false;
                // observer.disable();
            },
            onEnterBack: () => {
                
            },
            onLeaveBack: () => {
                animating = true;
                currentIndex -= 1;
                moveTo(".bottom_teaser");
            },
            onLeave: () => {
                clearInterval(interval);
                setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
                interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
            }
        });
    }
    
    function moveTo(classTarget) 
    {
        gsap.to(window, {
          scrollTo: {y: classTarget, autoKill: false},
          duration: 1,
          ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
          onComplete: () => {
            animating = false;
            clearInterval(interval);
            setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
            if (observer) {
                observer.enable();
            }
          }
        });
    }
    
    var tastingNoteIndex = 0;
    let timeout;
    
    function attachTastingNotesObserver()
    {
        const isMobile = window.matchMedia('(max-width: 700px)').matches;
        var scrollDelay = 500;
        var items = null;
        
        if (!isMobile) {
            items = $('.mobile-note-slides .slick-slide').not('.mobile-note-slides .slick-cloned')
        } else {
            items = $('.mobile-note-slide');
        }
        // const debouncedScroll = debounce(handleScroll, 2000);
        
        // if (isMobile) {
            
        //     const tastingNotesAnimate = gsap.timeline({
        // 		scrollTrigger: {
        // 			trigger: '.html--product-type--core .whisky-notes',
        // 			start: 'top+=1 bottom',
        // 			end: 'bottom top',
        // 			toggleActions: 'play none play reset',
        // 			onEnter: (section) => {
        //                  gsap.to(window, {
        //                   scrollTo: {y: ".whisky-notes", autoKill: false},
        //                   duration: 1,
        //                   ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
        //                   onComplete: () => {
                              
        //                     if ($(".whisky-notes").hasClass("tasting_notes_slider")) {
        //                         initializeTastingNoteObserver();      
        //                     }
        //                   }
        //                 });
        // 			},
        // 			onEnterBack: () => {
        // 			    gsap.to(window, {
        //                   scrollTo: {y: ".whisky-notes", autoKill: false},
        //                   duration: 1,
        //                   ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
        //                   onComplete: () => {
        //                       if ($(".whisky-notes").hasClass("tasting_notes_slider")) {
        //                         initializeTastingNoteObserver();
        //                       }
        //                   }
        //                 });
        // 			},
        // 			onLeave: () => {
        // 			}
        // 		}
        // 	});
        // } else {
        
            tastingNotesObserver = Observer.create({
                type: "wheel,touch,pointer",
                wheelSpeed: 0,
                onDown: () => {
                    
                    if (!animating) {
                        clearTimeout(timeout);
                        animating = true;
                        tastingNoteIndex++;
                    
                        if (tastingNoteIndex >= items.length) {
                            tastingNotesObserver.disable();
                    
                        } else {
                    
                            if (isMobile) {
                                scrollNextImage($(items[tastingNoteIndex]).attr('id'));
                            } else {
                                $(items[tastingNoteIndex]).click();
                            }
                        }
                        
                        timeout = setTimeout(function() {
                            const now = new Date()
                            animating = false;
                        }, scrollDelay);
                    }
                },
                onUp: () => {
                    const now = new Date()
                    
                    if (!animating) {
                        clearTimeout(timeout);
                        animating = true;
                        tastingNoteIndex--;
                    
                        if (tastingNoteIndex < 0) {
                    
                            tastingNotesObserver.disable();
                            // tastingNotesObserver = null;
                            gsap.to(window, {
                              scrollTo: {y: ".center-vid", autoKill: false},
                              duration: 1,
                              ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                              onComplete: () => {
                              }
                            });    
                            
                            
                        } else {
                            if (isMobile) {
                                scrollNextImage($(items[tastingNoteIndex]).attr('id'));
                            } else {
                                $(items[tastingNoteIndex]).click();
                            }
                        }
                        
                        timeout = setTimeout(function() {
                            
                            animating = false;
                        }, scrollDelay);
                    }
                },
                // onUpdate: () => {
                //     console.log("is updating " , tastingNoteIndex);
                // },
                // onScroll: debouncedScroll,
                // tolerance: scrollDelay,
                preventDefault: true,
            });
        // }
        
    }
    
    
    function scrollAnimateVideo(videoSource)
    {
        var newTime;
        var jumpspeed = 0.01;
        
        gsap.to(window, {
          scrollTo: {y: ".section-hero--container", autoKill: false},
          duration: 1,
          ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
          onComplete: () => {
              const is_mobile = window.matchMedia('(max-width: 700px)').matches;
              
              if (is_mobile) {
                  const tastingNotesAnimate = gsap.timeline({
            		scrollTrigger: {
            			trigger: '.html--product-type--core .whisky-notes',
            			start: 'top+=1 bottom',
            			end: 'bottom top',
            			toggleActions: 'play none play reset',
            // 			onEnter: (section) => {
            //                 initializeTastingNoteObserverGC();
            // 			},
            // 			onEnterBack: () => {
            //                 initializeTastingNoteObserverGC();
            // 			},
            			
            			onEnter: (section) => {
    			    
                             gsap.to(window, {
                              scrollTo: {y: ".whisky-notes", autoKill: false},
                              duration: 1,
                              ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                              onComplete: () => {
                                  
                                if ($(".whisky-notes").hasClass("tasting_notes_slider")) {
                                    initializeTastingNoteObserverGC();      
                                }
                              }
                            });
            			},
            			onEnterBack: () => {
            			    
            			    gsap.to(window, {
                              scrollTo: {y: ".whisky-notes", autoKill: false},
                              duration: 1,
                              ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                              onComplete: () => {
                                  if ($(".whisky-notes").hasClass("tasting_notes_slider")) {
                                    initializeTastingNoteObserverGC();
                                  }
                              }
                            });
            			},
            			
            			
            			onLeave: () => {
        			        tastingNotesObserver.disable()
            			},
            			onLeaveBack: () => {
        			        tastingNotesObserver.disable()
            			},
            		}
            	});
              }
          }
        });
    }
    
    function startAnimation() {
        // Get the video element
        grandVideo = document.querySelector('.desktop-video');
        scrollAnimateVideo(grandVideo);
    }
    
    if (document.body.classList.contains('grand-chateau')) {
        $('.bottom_teaser .center_image').show();
        startAnimation();
        
    } else {
        observer = Observer.create({
            // target: ".paragraph--type--timeline-item",
            ignore: [".scrolltrigger"],
            type: "wheel,touch,pointer",
            wheelSpeed: -1,
            onDown: () => {
                if (isMobile) {
                    !animating && animateSectionDownMob(currentIndex - 1, down);
                } else {
                    !animating && animateSectionDown(currentIndex - 1, down);
                }
              
            },
            onUp: () => {
                if (isMobile) {
                    !animating && animateSectionUpMob(currentIndex + 1, up);
                } else {
                    !animating && animateSectionUp(currentIndex + 1, up);
                }
            },
            onUpdate: () => {
            },
            tolerance: 40,
            preventDefault: true,
        });
        
        ScrollTrigger.create({
            trigger: ".scrolltrigger",
            start: "top-=1 top",
            end: "bottom bottom",
            // markers: true,
            onEnter: () =>  {
                animating = false;
                observer.disable();
                // clearInterval(interval);
            },
            onEnterBack: () => {
                player[0].currentTime = animTimelineThirdStart;
            },
            onLeaveBack: () => {
                animating = true;
                currentIndex -= 1;
                // player[0].currentTime = animTimelineThirdStart;
                
                gsap.to(window, {
                  scrollTo: {y: ".whisky-hero", autoKill: false},
                  duration: 1,
                  ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
                  onComplete: () => {
                    animating = false;
                    clearInterval(interval);
                    setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
                    interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
                    observer.enable();
                  }
                });
                
                
            },
            onLeave: () => {
                // player[0].pause();
                clearInterval(interval);
                setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
                interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
            }
        });
    }
    
    
    function setPlayerTimeline(start, end, initialized = true)
    {
        if (initialized) {
            startTime = start;
            endTime = end;
            if (player[0] != undefined) {
                player[0].currentTime = startTime;    
            }
            
        } else {
            clearInterval(interval);
        }
    }
    
    function animateSectionUp(index, direction)
    {
        if (index < 0) { 
            observer.disable();
            return false;
        }
        
        animating = true;
        
        let tl = gsap.timeline({
            defaults: {duration: 0.7, ease: "power1.inOut"},
        });
        // tl.set('.whisky-bottle-and-summary', { autoAlpha: 0 });
        
        if (index == 0)
        {
            // player[0].currentTime = 0;
            // setPlayerTimeline(0, 8);
            clearInterval(interval);
            
            setPlayerTimeline(animTimelineFirstStart, animTimelineFirstEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineFirstEnd - animTimelineFirstStart) * 1000), animTimelineFirstStart, animTimelineFirstEnd);
            currentIndex = index;    
        } else if (index == 1)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            fadeMenu();
            // $(".right_teaser").addClass('absolutePos');
            // tl.set('.right_teaser', { y: '100vh', });
            
            tl.to('.whisky-name', { y: '-100vh', duration: 1 }, 0.1)
            .to('.whisky-bottle-image', { y: '-65vh', duration: 1 }, 0)
            .to('.bottom_teaser', { y: '-100vh', duration: 1, onComplete: () => {
                animating = false;
                clearInterval(interval);
                setPlayerTimeline(animTimelineSecondStart, animTimelineSecondEnd);
                interval = setInterval(setPlayerTimeline, ((animTimelineSecondEnd - animTimelineSecondStart) * 1000), animTimelineSecondStart, animTimelineSecondEnd);
            } }, 0)
            currentIndex = index;
        } else if (index == 2)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            
            clearInterval(interval);
            setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
            tl.set('.whisky-long-description', { autoAlpha: 1 });
            tl.to('.whisky-bottle-image', { y: '-220vh', duration: 1 }, 0)
              .to('.bottom_teaser', { y: '-200vh', duration: 1, onComplete: () => {
              } }, 0)
              .to('.whisky-long-description', { y: descriptionPosition, duration: 1, onComplete: () => {
                animating = false;
              } }, 0)
            currentIndex = index;
        } else if (index == 3) {
            
             gsap.to(window, {
              scrollTo: {y: ".scrolltrigger", autoKill: false},
              duration: 1,
              ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
              onComplete: () => {
                animating = false;
                // player[0].pause();
                observer.disable();
              }
            });
            clearInterval(interval);
            currentIndex = index;
            return false;  
        }
    }
    
    function animateSectionDown(index, direction)
    {
        if (index < 0) { 
            currentIndex = 0;
            return false;
        }
        
        animating = true;
        
        let tl = gsap.timeline({
            defaults: {duration: 0.7, ease: "power1.inOut"},
        });
        // tl.set('.whisky-bottle-and-summary', { autoAlpha: 0 });
        
        if (index == 0)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            
            // $(".right_teaser").addClass('absolutePos');
            // tl.set('.right_teaser', { y: '100vh', });
            clearInterval(interval);
            setPlayerTimeline(animTimelineFirstStart, animTimelineFirstEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineFirstEnd - animTimelineFirstStart) * 1000), animTimelineFirstStart, animTimelineFirstEnd);
            tl.to('.whisky-name', { y: '0vh', duration: 1, onComplete: () => {
                animating = false;
                
            } }, 0.2)
            .to('.whisky-bottle-image', { y: '0vh', duration: 1 }, 0)
            .to('.bottom_teaser', { y: '0vh', duration: 1, onComplete: () => {
                
            } }, 0);
            
            showMenu();
            currentIndex = index;    
        } else if (index == 1)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            fadeMenu();
            
            tl.to('.whisky-name', { y: '-100vh', duration: 1, onComplete: () => {
                animating = false;
            } }, 0.2)
            .to('.whisky-bottle-image', { y: '-65vh', duration: 1 }, 0)
            .to('.bottom_teaser', { y: '-100vh', duration: 1, onComplete: () => {
                clearInterval(interval);
                setPlayerTimeline(animTimelineSecondStart, animTimelineSecondEnd);
                interval = setInterval(setPlayerTimeline, ((animTimelineSecondEnd - animTimelineSecondStart) * 1000), animTimelineSecondStart, animTimelineSecondEnd);
            } }, 0)
            .to('.whisky-long-description', { y: '0vh', duration: 1 }, 0)
            currentIndex = index;
        } else if (index == 2)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            
            tl.to('.whisky-bottle-image', { y: '-65vh', duration: 1, onComplete: () => {
                animating = false;
              } }, 0)
              .to('.bottom_teaser', { y: '-100vh', duration: 1, onComplete: () => {
                clearInterval(interval);
                setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
                interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
              } }, 0)
              
            currentIndex = index;
        }
    }
    
    function animateSectionUpMob(index, direction)
    {
        if (index < 0) { 
            observer.disable();
            return false;
        }
        
        animating = true;
        
        
        let tl = gsap.timeline({
            defaults: {duration: 0.7, ease: "power1.inOut"},
        });
        // tl.set('.whisky-bottle-and-summary', { autoAlpha: 0 });
        
        if (index == 0)
        {
            clearInterval(interval);
            setPlayerTimeline(animTimelineFirstStart, animTimelineFirstEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineFirstEnd - animTimelineFirstStart) * 1000), animTimelineFirstStart, animTimelineFirstEnd);
            currentIndex = index;    
        } else if (index == 1)
        {
            
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            fadeMenu();
            
            tl.to('.whisky-name', { y: '-100vh', duration: 1 }, 0.2)
            .to('.whisky-bottle-image', { y: '-80vh', duration: 1 }, 0)
            .to('.bottom_teaser', { y: '-100vh', duration: 1, onComplete: () => {
                animating = false;
                clearInterval(interval);
                setPlayerTimeline(animTimelineSecondStart, animTimelineSecondEnd);
                interval = setInterval(setPlayerTimeline, ((animTimelineSecondEnd - animTimelineSecondStart) * 1000), animTimelineSecondStart, animTimelineSecondEnd);
            } }, 0)
            currentIndex = index;
        } else if (index == 2)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            
            clearInterval(interval);
            setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
            tl.set('.whisky-long-description', { autoAlpha: 1 });
            tl.to('.whisky-bottle-image', { y: '-220vh', duration: 1 }, 0)
              .to('.bottom_teaser', { y: '-200vh', duration: 1 }, 0)
              .fromTo('.whisky-long-description', {y: '74vh'}, { y: '-80vh', duration: 1, onComplete: () => {
                animating = false;
              } }, 0)
            currentIndex = index;
        } else if (index == 3) {
             gsap.to(window, {
              scrollTo: {y: ".scrolltrigger", autoKill: false},
              duration: 1,
              ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
              onComplete: () => {
                animating = false;
              }
            });
            // clearInterval(interval);
            observer.disable();
            currentIndex = index;
            return false;  
        }
    }
    
    function animateSectionDownMob(index, direction)
    {
        if (index < 0) { 
            currentIndex = 0;
            return false;
        }
        
        animating = true;
        
        
        let tl = gsap.timeline({
            defaults: {duration: 0.7, ease: "power1.inOut"},
        });
        // tl.set('.whisky-bottle-and-summary', { autoAlpha: 0 });
        
        if (index == 0)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            
            // $(".right_teaser").addClass('absolutePos');
            // tl.set('.right_teaser', { y: '100vh', });
            clearInterval(interval);
            setPlayerTimeline(animTimelineFirstStart, animTimelineFirstEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineFirstEnd - animTimelineFirstStart) * 1000), animTimelineFirstStart, animTimelineFirstEnd);
            tl.to('.whisky-name', { y: '0vh', duration: 1, onComplete: () => {
                animating = false;
            } }, 0.2)
            .to('.whisky-bottle-image', { y: '0vh', duration: 1 }, 0)
            .to('.bottom_teaser', { y: '0vh', duration: 1, onComplete: () => {
                
            } }, 0);
            
            showMenu();
            currentIndex = index;    
        } else if (index == 1)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            fadeMenu();
            
            tl.to('.whisky-name', { y: '-100vh', duration: 1, onComplete: () => {
                animating = false;
            } }, 0.2)
            .to('.whisky-bottle-image', { y: '-80vh', duration: 1 }, 0)
            .to('.bottom_teaser', { y: '-100vh', duration: 1, onComplete: () => {
                clearInterval(interval);
                setPlayerTimeline(animTimelineSecondStart, animTimelineSecondEnd);
                interval = setInterval(setPlayerTimeline, ((animTimelineSecondEnd - animTimelineFirstStart) * 1000), animTimelineSecondStart, animTimelineSecondEnd);
            } }, 0)
            .to('.whisky-long-description', { y: '74vh', duration: 1, onComplete: () => {
                
            } }, 0)
            currentIndex = index;
        } else if (index == 2)
        {
            let tl = gsap.timeline({
                defaults: {duration: 0.7, ease: "power1.inOut"},
            });
            
            clearInterval(interval);
            setPlayerTimeline(animTimelineThirdStart, animTimelineThirdEnd);
            interval = setInterval(setPlayerTimeline, ((animTimelineThirdEnd - animTimelineThirdStart) * 1000), animTimelineThirdStart, animTimelineThirdEnd);
            tl.to('.whisky-bottle-image', { y: '-80vh', duration: 1, onComplete: () => {
                animating = false;
              } }, 0)
              .to('.bottom_teaser', { y: '-100vh', duration: 1, onComplete: () => {
              } }, 0)
              
            currentIndex = index;
        }
    }
    
    var displayingHeader = true;
    function fadeMenu()
    {
        var headerTimeline = gsap.timeline();
        if (displayingHeader)  {
    		headerTimeline.to(".site--logo .image_bottle img", { autoAlpha: 0, duration: 0 }, 0)
            .to(".site--name", { autoAlpha: 0, duration: 0.5 }, 0)
            .to(".bottom-border", { autoAlpha: 0, duration: 0.5 }, 0);
            displayingHeader = false;
            if (is_US) {
                const enterAnim = gsap.timeline();
                $("#header").toggleClass("minimize");
                enterAnim.fromTo("#whisky-cta", { autoAlpha: 0, zIndex: 1 }, { autoAlpha: 1, zIndex: 9, duration: 0.5 }, 0.5);
    	   // 	$(".floater-container").fadeIn('fast');
            }
    	}
    }
    
    function showMenu()
    {
        var headerTimeline = gsap.timeline();
        if (!displayingHeader) {
            if (is_US) {
                
                const enterAnim2 = gsap.timeline();
                $("#header").toggleClass("minimize");
                enterAnim2.fromTo("#whisky-cta", { autoAlpha: 1, zIndex: 9}, { autoAlpha: 0, zIndex: -1, duration: 0.5 }, 0);
    	       // $(".floater-container").fadeOut('fast');
            }
            
	        headerTimeline.to(".site--logo .image_bottle img", { autoAlpha: 1, duration: 0.5 }, 0)
	            .to(".site--name", { autoAlpha: 1, duration: 0.5 }, 0)
	            .to(".bottom-border", { autoAlpha: 1, duration: 0.5 }, 0);
	        displayingHeader = true;
        }
    }
    
    function animateCoreDesktop()
    {
        if (!is_US) {
            ScrollTrigger.create({
                trigger: ".html--product-type--core .scrolltrigger",
                start: "top top",
                end: "bottom bottom",
                // markers: true,
                onEnter: () =>  {
                  const enterAnim = gsap.timeline();          
                //   enterAnim.fromTo("#header", { autoAlpha: 1, zIndex: 10 }, { autoAlpha: 1, zIndex: -1, duration: 0.5 }, 0)
                  $("#header").toggleClass("minimize");
                  enterAnim.fromTo("#whisky-cta", { autoAlpha: 0, zIndex: 1 }, { autoAlpha: 1, zIndex: 9, duration: 0.5 }, 0);
	    	      //$(".floater-container").fadeIn('fast');
	    	      if ($(".black-header").length) {
                    $(".menu-toggle").toggleClass("white-menu");    
                  }
                },
                onEnterBack: () => {
                  
                },
                onLeaveBack: () => {
                  const enterAnim2 = gsap.timeline();
                //   enterAnim2.fromTo("#header", { autoAlpha: 1, zIndex: -1}, { autoAlpha: 1, zIndex: 10, duration: 0.5 }, 0)
                  $("#header").toggleClass("minimize");
                  enterAnim2.fromTo("#whisky-cta", { autoAlpha: 1, zIndex: 9}, { autoAlpha: 0, zIndex: -1, duration: 0.5 }, 0);
    		      //  $(".floater-container").fadeOut('fast');
    		      if ($(".black-header").length) {
                    $(".menu-toggle").toggleClass("white-menu");    
                  }
                },
                onLeave: () => {
                  
                }
            });
        }
        
    	const doublePanelContentIntroAnimate = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.html--product-type--core .paragraph--type--double-panel-content',
    			start: 'top+=1 bottom',
    			end: 'top-=1 top',
    			toggleActions: 'play none play reset',
    			onEnter: (section) => {
    			    
    			},
    			onLeaveBack: () => {
    			 //   gsap.to("#block-gf-theme-branding", { autoAlpha: 1 }, 0)
        //             gsap.to("#whisky-cta", { autoAlpha: 0 }, 0);
    			}
    		}
    	});
    	doublePanelContentIntroAnimate.from('.paragraph--type--double-panel-content .paragraph_content', { duration: 0.5, opacity: 0, x: -200, ease: "power1.out" }, 0.5)
    		.from('.paragraph--type--double-panel-content .paragraph_image img', { duration: 0.5, opacity: 0, x: 200, onComplete: doneAnimatingFunc, ease: "power1.out" }, 1)
    // 		.to("#block-gf-theme-branding", { autoAlpha: 0 }, 0)
    //         .to("#whisky-cta", { autoAlpha: 1 }, 0);
    
    	// Where Next Slider
    	const simpleTastingNotesSliderAnimate = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.html--product-type--core .paragraph--type--carousel-section.tasting_notes',
    			start: 'top+=1 bottom',
    			end: 'top-=1 top',
    			toggleActions: 'play none play reset',
    			onEnter: (section) => {
    			},
    		}
    	});
    	simpleTastingNotesSliderAnimate.from('.paragraph--type--carousel-section.tasting_notes .paragraph_title', { duration: 1, opacity: 0, y: 50, ease: "power1.out" }, 0.3)
    		.from('.paragraph--type--carousel-section.tasting_notes .mobile-note-slides .mobile-note-slide .slide-down-holder', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.5)
    		.from('.paragraph--type--carousel-section.tasting_notes .mobile-note-slides .mobile-note-slide p', { duration: 1, stagger: 0.1, opacity: 0, y: 200, onComplete: doneAnimatingFunc, ease: "power1.out" }, 0.5);
    
    	// Where Next Slider
    	const whereNextSliderAnimate = gsap.timeline({
    		scrollTrigger: {
    			trigger: '.html--product-type--core .where-next',
    			start: 'top+=1 bottom',
    			end: 'top-=1 top',
    			toggleActions: 'play none play reset',
    			onEnter: (section) => {
    			},
    		}
    	});
    	whereNextSliderAnimate.set('.where-next .title-and-nav', { zIndex: 9 }, 0)
    		.from('.where-next .title-and-nav', { duration: 1, opacity: 0, y: 50, ease: "power1.out" }, 0.5)
    		.from('.collection-whisky-listing .collection-slide-image-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.8)
    		.from('.collection-whisky-listing .collection-content-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, onComplete: doneAnimatingFunc, ease: "power1.out" }, 1);
    }
}